import { MediaService } from "../media/MediaService";

export const getUserIcon = function (user: any) {
  return new MediaService().resizeCloudinaryImage(user.icon, 250) || user.icon;
};
